import React from 'react'
import PropTypes from 'prop-types'
import useCase from '../hooks/use-case'

function WhenCaseIn (props) {
  const caseValue = useCase()

  if (props.values.indexOf(caseValue) === -1) {
    return null
  }

  return props.children
}

WhenCaseIn.defaultProps = {
  values: null
}

WhenCaseIn.propTypes = {
  values: PropTypes.array.isRequired
}

export default WhenCaseIn
